<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode_person">
            <div v-if="personForm.isSport=='0'" id="queryArea_person" style="width:100%; text-align:center; margin-top:10px;">
                <el-select v-model="personForm.courseType" filterable placeholder="默认全部选修课类型" style="width: 80%;" @change="changeCourseType" clearable>
                    <el-option v-for="item in courseTypeInfo" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                    </el-option>
                </el-select>
            </div>
            <div id="listArea_person" @scroll="handleScroll">
                <div v-if="personalInfoData==null || personalInfoData.length==0" class="cardTips">没有选课记录</div>

                <div class="cardMain" v-for="(item,index) in personalInfoData" :key="index">
                    <div class="cardText">
                        <p><label for="">学年学期：</label>{{ item.xnxqmc }}</p>
                        <p><label for="">选修班名称：</label>{{ item.electiveClassName }}</p>
                        <p><label for="">学分：</label>{{ item.credit }}</p>
                    </div>
                    <div class="cardInput" >
                        <el-button size="small" v-if="item.curXnxq == item.xnxqbm && item.selectCourse=='1'" @click="delSelection(item);" type="danger">
                            删除
                        </el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>personalInfoData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { confirmMsg, showNotify } from "utils/message";
    import personInfo from './personInfo.vue';

    export default {
        props: ['isDivideTab'],
        components:{
            personInfo,
        },
        data() {
            return {
                personForm: {
                    pageNum: 1,
                    rowNum: 10,
                    xnxqbm: null,
                    electiveDetailCode: null,
                    courseType: "",
                    courseName: null,
                    state: null,
                    isDivideTab: null,//是否体育选修课
                },
                xnxqInfo: [], //学年学期下拉框
                courseTypeInfo: [], //课程类型下拉框
                courseInfo: [], //课程下拉框
                classWeekInfo: [], //上课日期下拉框
                classTimeInfo: [], //上课时间下拉框
                examinationFormInfo: [], //考试形式下拉框
                registrableDeptInfo: [], //可报名系部下拉框
                registrableMajorInfo: [], //可报名专业下拉框
                registrableClassInfo: [], //可报名班级下拉框
                registrableGradeInfo: [], //可报名年级下拉框
                registrableRecruitNatureInfo: [], //可报名层次类型下拉框
                sportInfo: [],//是否体育选修课下拉框
                stateInfo: [],//状态下拉框
                majorInfo: [],//专业下拉框
                gradeInfo: [],//年级下拉框
                tableData: [],
                currentXnxq: null,//当前学期
                checkSelection: false,//是否在选课时间范围内
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: null,
                mainTableHeight: 500,
                dialogTitle: "",
                dialogVisible: false,
                formSubmiting: false,
                editType: null,
                stuInfo: null,

                limit_personalInfo : 10,
                currentPage_personalInfo: 1,
                personalInfoData: [],
                personalInfoTableHeight: 500,
                personalInfoDialogVisible: false,
                topHeight: 0+'px',
                errorDialogVisible: false,
                errorMessage: '',

                applyForm: {
                    xnxqbm: '',
                    electiveClassName: '',
                    courseTypeName: '',
                    quotaNumber: null,
                    teachingWeek: '',
                    classWeek: '',
                    classTime: '',
                    teacherName: '',
                    siteName: '',
                    credit: null,
                    totalClassHours: null,
                    examinationForm: null,
                    remarks: null,
                },
            };
        },
        created() {
            this.initParam();
        },
        mounted() {
            this.personForm.isSport = this.isSport;
        },
        methods: {
            showHomePage(){
                this.$router.push('/m/wx/home');
            },
            initParam(){
                this.initOption();

                //判断是否在选课时间范围内
                this.$api.electiveManage.studentSelection.checkSelectTime({
                    data: {}
                }).then(response => {
                    this.currentXnxq = response.data.data.xnxqbm;
                    this.queryStuSelection();
                }).catch(error => {
                    console.log(error);
                });
            },
            initOption(){
                const paramMap = {
                    'name': 'combo_Info'
                }
                this.$api.electiveManage.studentSelection.initOption({
                    data: paramMap
                }).then(response => {
                    this.courseTypeInfo = response.data.data.courseType;
                }).catch(error => {
                    console.log(error);
                });
            },
            handleScroll(){
                if(this.checkVisible() && !this.tableLoading && this.total>this.tableData.length){
                    this.currentPage++;
                    this.queryStuSelection();
                }
            },
            checkVisible() {
                const ele = document.getElementById('loadingTips');
                if(ele){
                    let rect = ele.getBoundingClientRect();
                    //获取当前浏览器的视口高度，不包括工具栏和滚动条
                    //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                    let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                    //bottom top是相对于视口的左上角位置
                    //bottom大于0或者top-视口高度小于0可见
                    return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
                }else{
                    return false;
                }
            },
            scrollToTop(){
                const ele = document.getElementById('listArea');
                if(ele){
                    ele.scrollTop = 0;
                }
            },

            setMainDialogStyle(top, height){
                document.getElementById('mainDialog').style.top = top;
                this.$nextTick(() => {
                    document.getElementById('mainDialogScroll').style.height = height;
                });
            },
            restoreScroll(){
                this.$nextTick(() => {
                    this.$refs.mainDialogScroll.wrap.scrollTop = 0;
                });
            },
            closeDialog() {
                this.dialogVisible = false;

                if(this.$refs['applyForm'] !== undefined){
                    this.$refs['applyForm'].resetFields();
                }

            },
            rowClick(row) {
                this.selectRowData = row;
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            closeErrorDialog() {
                this.errorMessage = '';
                this.errorDialogVisible = false;
            },
            personalInfo(){
                this.queryStuSelection();
                this.personalInfoDialogVisible = true;
            },
            //查询学生所有选课信息
            queryStuSelection() {
                this.tableLoading = true;
                this.personForm.pageNum = this.currentPage_personalInfo;
                this.personForm.rowNum = this.limit_personalInfo;
                this.personForm.xnxqbm = this.currentXnxq;
                this.personForm.isDivideTab = this.isDivideTab;

                this.$api.electiveManage.studentSelection.queryStuSelection({
                    data: this.personForm,
                }).then((response) => {
                    this.personalInfoData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            changeCourseType(){
                this.queryStuSelection();
            },
            delSelection(row){
                const paramMap = {
                    'xnxqbm': this.currentXnxq,
                    'electiveDetailCode': row.electiveDetailCode,
                    'studentCode': row.studentCode,
                    'isDivideTab': '0',
                };
                confirmMsg('是否确认删除该选课信息？', 'el-message-box-mobile').then(() => {
                    this.$api.electiveManage.studentSelection.delSelection({
                        data: paramMap
                    }).then(response => {
                        let state = response.data.data.state;
                        let msg = response.data.data.msg;

                        if (state == 'Success') {
                            this.$notify({
                                title: "成功",
                                message: msg ? msg : "删除成功",
                                type: "success",
                                duration: 1500,
                            });
                            this.queryStuSelection();
                            this.$emit("closePersonInfoDialog");
                        }else{
                            this.$notify({
                                title: "失败",
                                message: msg ? msg : '删除失败',
                                type: "error",
                                duration: 3000,
                            });
                        }
                    }).catch(error => {
                        this.formSubmiting = false;
                        this.$notify({
                            title: '错误',
                            message: error, /// l..
                            type: 'error',
                            duration: 3000,
                        });
                        console.log(error);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            closePersonalInfoDialog(){
                this.personalInfoDialogVisible = false;
            },
            //失去焦点直接获取输入的单位名称
            unitblur(e, item, index){
                if(e.target.value != ''){
                    this.editForm.internshipUnitId = e.target.value;
                }
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
        }
    };
</script>
<style src="styles/mobile.css"></style>
<style>
    #mobileMode #queryDialog {
        top: 150px;
    }

    #mobileMode #mainDialogScroll {
        height: 65vh;
        padding: 10px 20px;
    }

    #mobileMode #loadingTips {
        height: 30px;
        line-height: 30px;
        color: #9d9d9d;
        position: relative;
        bottom: 0;
        text-align: center;
    }

    /* 个人选课页面 */
    #mobileMode_person {
        height: 80vh;
        width: 100%;
        margin: 0;
        overflow: hidden;
    }
    #mobileMode_person #listArea_person {
        height: calc(100% - 80px);
        overflow-y: auto;
        margin-top: 12px;
    }
    #mobileMode_person #listArea_person .cardTips {
        width: 90%;
        height: 100%;
        font-size: 18px;
        font-weight: bold;
        color: #DCDFE6;
        border: 1px solid #DCDFE6;
        border-radius: 5px;
        margin-left: 5%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    #mobileMode_person #listArea_person .cardMain {
        margin: 0.5em 0 1em 0;
        width: 90%;
        height: auto;
        box-shadow: 0 0 10px #e7e7e7;
        border-radius: 10px;
        margin-left: 5%;
    }
    #mobileMode_person #listArea_person .cardText {
        padding: 0.2em 01em 0.2em 1em;
        position: relative;
    }
    #mobileMode_person #listArea_person .cardText label {
        width: 100px;
        display: inline-block;
    }
    #mobileMode_person #listArea_person .cardInput {
        border-top: 1px #e7e7e7 solid;
        padding: 0.5em;
        text-align: right;
    }
    #mobileMode_person #listArea_person .cardText .auditStateImg {
        width: 100px;
        height: 100px;
        position: absolute;
        right: 0;
        top: 0;
    }
    #mobileMode_person #listArea_person .auditStateImg img {
        width: 100%;
        height: 100%;
    }
    /* 个人选课页面结束 */
</style>



// WEBPACK FOOTER //
// personInfo.vue?3994ceb6